export class AlertHelper {
  constructor({ i18n }) {
    this.i18n = i18n;
    this.currentAlertId = null;
  }

  getAlertCenter() {
    return window.App.views.alertCenter;
  }
  dismissAlert() {
    if (this.currentAlertId) {
      this.getAlertCenter().dismiss(this.currentAlertId);
      this.currentAlertId = null;
    }
  }

  showAlert(message) {
    this.dismissAlert();
    this.currentAlertId = this.getAlertCenter().show({
      message,
      level: 'Error',
      dismissible: true,
    }, this.currentAlertId);
  }

  showUnknownError() {
    const unexpectedError = this.i18n.getString('ErrorNumber_-1');

    this.showAlert(unexpectedError);
  }

  showSuccess(message) {
    this.getAlertCenter().toastConfirmation(message);
  }

  showInfo(message) {
    this.getAlertCenter().toastInfo(message);
  }

  showWarning(message) {
    this.getAlertCenter().toastWarning(message);
  }

  showError(message) {
    this.getAlertCenter().toastError(message);
  }
}
